// extracted by mini-css-extract-plugin
export default {"container":"MessageFormButtons_container__fqAN9"};